import React from 'react';
import { styled } from '@linaria/react';

import { Wrapper as ArticleWrapper } from '@/components/LayoutArticle';
import { Wrapper as TutorialWrapper } from '@/components/LayoutTutorial';

import {
  ICON_MAX_WIDTH_ARTICLE,
  ICON_MAX_WIDTH_TUTORIAL,
} from './Aside.constants';
import { TOC_THRESHOLD } from '@/components/ContentGrids/TutorialGrid';

interface Props {
  children: React.ReactNode;
}

function LeftEdgeBase({ children }: Props) {
  return (
    <>
      <DesktopWrapper>
        {children}
        <Filler />
      </DesktopWrapper>

      <MobileEdge />
    </>
  );
}

const DesktopWrapper = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  bottom: 0;
  height: 100%;
  display: flex;
  flex-direction: column;
  transform: translateX(-3px);

  ${ArticleWrapper} & {
    @media (max-width: ${ICON_MAX_WIDTH_ARTICLE || 0}rem) {
      display: none;
    }
  }

  /* So the funky thing about Tutorials is that when the TOC disappears, we suddenly have much more space, and can fit the icon! So we need to be very selective about our breakpoints */
  ${TutorialWrapper} & {
    @media (max-width: ${ICON_MAX_WIDTH_TUTORIAL}rem) {
      display: none;
    }
    @media (max-width: ${TOC_THRESHOLD}rem) {
      display: flex;
    }
    @media (max-width: ${ICON_MAX_WIDTH_ARTICLE}rem) {
      display: none;
    }
  }
`;

const Filler = styled.div`
  flex: 1;
  width: 3px;
  background: var(--color-primary);
  border-radius: 0 0 100px 100px;
  margin-top: -1px;
`;

const MobileEdge = styled.div`
  display: none;
  position: absolute;
  top: 0;
  left: -3px;
  bottom: 0;
  width: 3px;
  height: 100%;
  background: var(--color-primary);
  border-radius: 10px;

  ${ArticleWrapper} & {
    @media (max-width: ${ICON_MAX_WIDTH_ARTICLE}rem) {
      display: revert;
    }
  }

  ${TutorialWrapper} & {
    @media (max-width: ${ICON_MAX_WIDTH_TUTORIAL}rem) {
      display: revert;
    }
    @media (max-width: ${TOC_THRESHOLD}rem) {
      display: none;
    }
    @media (max-width: ${ICON_MAX_WIDTH_ARTICLE}rem) {
      display: revert;
    }
  }
`;

export default LeftEdgeBase;
